import { coerce, date, type Infer, object, string } from "superstruct";

const IsoDate = coerce(date(), string(), (value) => new Date(value));

export const ProjetSchema = object({
    id: string(),
    label: string(),
    createdAt: IsoDate,
});

export type Projet = Infer<typeof ProjetSchema>;
